'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Button from '@/components/ui/Button';
import BookDemoModal from '@/components/ui/BookDemoModal';
import { FaBars } from 'react-icons/fa';

// Кастомная иконка AI
const AiTextIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="12" fill="#01A7FF" />
    <text
      x="50%"
      y="55%"
      textAnchor="middle"
      fill="white"
      fontSize="12"
      fontWeight="bold"
      fontFamily="Inter, Arial, sans-serif"
      dy=".3em"
    >
      AI
    </text>
  </svg>
);

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isBookDemoOpen, setIsBookDemoOpen] = useState(false);

  const [scrolled, setScrolled] = useState(false);

  // Transparent over the hero photo, frosted once the page moves under it.
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const openBookDemo = () => {
    // Track click conversion
    if (typeof window !== 'undefined' && window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }

    setIsBookDemoOpen(true);
    setIsMobileMenuOpen(false); // Закрываем мобильное меню если оно открыто
  };

  const closeBookDemo = () => {
    setIsBookDemoOpen(false);
  };

  return (
    <>
      <header
        className={`fixed inset-x-0 top-0 z-[70] py-4 px-4 w-full flex flex-col lg:flex-row lg:items-center lg:justify-between transition-[background-color,box-shadow,backdrop-filter] duration-300 ${
          scrolled
            ? 'bg-white/80 shadow-[0_8px_30px_rgba(2,32,71,0.08)] backdrop-blur-md'
            : 'bg-white/0'
        }`}
      >
        <div className="flex items-center w-full justify-between lg:w-auto">
          <Link href="/">
            <Image src="/images/img_vector.svg" alt="Lensync Logo" width={115} height={24} />
          </Link>
          <button
            className="lg:hidden text-[#01A7FF]"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Open menu"
          >
            <FaBars size={28} />
          </button>
        </div>

        <div className="hidden lg:flex items-center space-x-8 justify-center flex-1">
          <Link href="#how-it-works" className="text-[#121115] text-base font-normal">
            How it works
          </Link>
          <Link href="#why-us" className="text-[#121115] text-base font-normal">
            Why us
          </Link>
          <Link
            href="#lensync-ai"
            className="text-[#121115] text-base font-normal flex items-center gap-1"
          >
            <AiTextIcon style={{ width: 22, height: 22 }} />
            LenSync AI
          </Link>
        </div>

        <div className="hidden lg:block lg:ml-8">
          <Button variant="primary" className="rounded-md" onClick={openBookDemo}>
            Contact
          </Button>
        </div>
      </header>

      {/* outside <header>: its backdrop-filter would trap a fixed overlay */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-[9999] flex justify-start">
          <div className="bg-white w-64 h-full p-4 pt-6 flex flex-col space-y-6 shadow-lg">
            <div className="flex items-center justify-between mb-4">
              <Link href="/">
                <Image src="/images/img_vector.svg" alt="Lensync Logo" width={115} height={24} />
              </Link>
              <button
                className="self-end ml-2"
                onClick={() => setIsMobileMenuOpen(false)}
                aria-label="Close menu"
              >
                ✕
              </button>
            </div>
            <Link
              href="#how-it-works"
              className="text-[#121115] text-base font-normal"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              How it works
            </Link>
            <Link
              href="#why-us"
              className="text-[#121115] text-base font-normal"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Why us
            </Link>
            <Link
              href="#lensync-ai"
              className="text-[#121115] text-base font-normal flex items-center gap-2"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <AiTextIcon style={{ width: 22, height: 22 }} />
              LenSync AI
            </Link>
            <Button variant="primary" className="rounded-md mt-4" onClick={openBookDemo}>
              Contact
            </Button>
          </div>
          <div className="flex-1" onClick={() => setIsMobileMenuOpen(false)} />
        </div>
      )}

      <BookDemoModal isOpen={isBookDemoOpen} onClose={closeBookDemo} />
    </>
  );
};

export default Header;
